(function () {
    angular.module('acordoConsulta', []);
})();